<template>
  <session class="page-left-navs" @click="toggleLeftNavExpand">
    <Icon name="category" />
  </session>

  <Transition name="mlnfade">
    <section class="page-left-navs-full" v-show="leftNavExpand">
      <div class="page-left-navs-full-inner">
        <div class="page-left-navs-t">
          <div class="closewrap" @click="toggleLeftNavExpand"><Icon name="close" /></div>
          <div class="page-left-navs-tr">
            <img class="logo" src="@/assets/images/logo-en.svg" v-if="!getLocalLangCode() || getLocalLangCode() == 'en'" />
            <img class="logo" src="@/assets/images/logo.svg" v-if="getLocalLangCode() == 'zh'" />
            <img class="logo" src="@/assets/images/logo-jp.svg" v-if="getLocalLangCode() == 'jp'" />
            <img class="logo" src="@/assets/images/logo-kr.svg" v-if="getLocalLangCode() == 'kr'" />
          </div>
        </div>
        <div class="page-left-navs-b">
          <div class="page-left-navs-bl">
            <div class="page-left-navs-blt">
              <div class="navs">
                <div class="item" v-for="(item, index) in navs" @click="toTagetPage(item)"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.label }}</span></div>
              </div>
              <div class="protocols">
                <div class="item" v-for="(item, index) in protocolEntrances" @click="toTagetPage(item)"><span>{{ item?.label }}</span></div>
              </div>
            </div>
            <div class="page-left-navs-blb">
              <div class="loginwrap" @click="Utils.loginDialogToggle(true)">
                <Icon name="checkmore white" size="24" />
                <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('login') }}</span>
              </div>
              <span class="copyright">{{ LOCAL('copyRight') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Transition>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import * as Utils from '@/assets/utils';
  import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
  import Icon from '@/components/icon/index.vue';
  import router from '@/router';

  const langCode = ref('');
  onMounted(() => {
    langCode.value = getLocalLangCode();
  })

  const leftNavExpand = ref(false);
  const toggleLeftNavExpand = () => {
    leftNavExpand.value = !leftNavExpand.value;
  }

  const navs = ref([]);
  const protocolEntrances = ref([]);
  const init = () => {
    navs.value = [
      { label: LOCAL('home'), path: '/home' },
      { label: LOCAL('aboutUs'), path: '/aboutus' },
      { label: LOCAL('productService'), path: '/productservice' },
      { label: LOCAL('claims'), path: '/claims' },
      { label: LOCAL('questions'), path: '/questions' },
      { label: LOCAL('contactUs'), path: '/contactus' },
    ];
    protocolEntrances.value = [
      { label: LOCAL('privacyPolicy'), path: '/protocol/private' },
      { label: LOCAL('termsUse'), path: '/protocol/term' }
    ];
  }
  onMounted(() => {
    init()
  });

  const toTagetPage = item => {
    toggleLeftNavExpand();
    router.push(item?.path || '/');
  }

  const toTagetPage2 = item => {
    toggleLeftNavExpand();
    window.location.href = item?.path
  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
